import React from "react"
import {
  AppBar,
  Avatar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  styled,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material"
import { Link, useNavigate } from "react-router-dom"
import logo from "../images/logo.png"
import { logout } from "../features/auth/authSlice"
import { useDispatch, useSelector } from "react-redux"
import decode from "jwt-decode"
import {
  Menu as MenuIcon,
  Login,
  Email,
  Home,
  Article,
  Quiz,
  DirectionsBus,
  Newspaper,
} from "@mui/icons-material"

const Navbar = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { user } = useSelector((state) => state.auth)
  const [open, setOpen] = React.useState(false)

  const handleLogOut = () => {
    dispatch(logout())
    navigate("/auth")
  }

  React.useEffect(() => {
    if (user?.token) {
      const decodedToken = decode(user?.token)
      if (decodedToken.exp * 1000 < new Date().getTime()) handleLogOut()
    }
  }, [])

  const ToolbarStyled = styled(Toolbar)({
    display: "flex",
    justifyContent: "space-between",
  })
  const LogoStyled = styled(Box)({
    display: "flex",
    gap: 10,
    marginLeft: 20,
    alignItems: "center",
  })

  const UserBox = styled(Box)(({ theme }) => ({
    display: "none",
    alignItems: "center",
    gap: 10,
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  }))
  const MenuBox = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: 20,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.down("md")]: {
      gap: 5,
    },
  }))
  const MenuItems = [
    { name: "Home", link: "/", icon: <Home /> },
    { name: "Posts", link: "/posts", icon: <Newspaper /> },
    { name: "Quiz", link: "/quiz", icon: <Quiz /> },
    { name: "Jobs", link: "/jobs", icon: <DirectionsBus /> },
    { name: "Contacts", link: "/contacts", icon: <Email /> },
    { name: "Log In / Sign Up", link: "/auth", icon: <Login /> },
  ]
  const NavbarItems = [
    {
      name: "Home",
      link: "/",
      icon: <Home />,
    },
    {
      name: "Posts",
      link: "/posts",
      icon: <Newspaper />,
    },
    { name: "Quiz", link: "/quiz", icon: <Quiz /> },
    { name: "Jobs", link: "/jobs", icon: <DirectionsBus /> },
    { name: "Contacts", link: "/contacts", icon: <Email /> },
  ]

  return (
    <AppBar
      position="static"
      color="inherit"
      sx={{ borderRadius: 15, margin: "30px 0" }}
    >
      <ToolbarStyled>
        <LogoStyled component={Link} to="/">
          <Box>
            <img src={logo} alt="icon" height={40} />
          </Box>
        </LogoStyled>
        <MenuBox>
          {NavbarItems.map((item, index) => (
            <Tooltip key={index} title={item.name}>
              <IconButton
                component={Link}
                to={`${item.link}`}
                sx={{
                  ":hover": {
                    color: "#d32f2f",
                  },
                }}
              >
                {item.icon}
              </IconButton>
            </Tooltip>
          ))}
        </MenuBox>

        <UserBox>
          {user ? (
            <>
              <Avatar
                alt={user?.result?.name}
                src={`${process.env.REACT_APP_URL}${user?.result?.avatarImage}`}
              />
              <Typography
                variant="h6"
                align="center"
                color="primary"
                sx={{ display: { sm: "none", md: "block" } }}
              >
                {user?.result?.name}
              </Typography>

              <Button
                variant="contained"
                onClick={handleLogOut}
                color="error"
                sx={{ borderRadius: 15 }}
              >
                Logout
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="contained"
                component={Link}
                to="/auth"
                color="error"
                sx={{ borderRadius: 15 }}
              >
                Sign In
              </Button>
            </>
          )}
        </UserBox>
        <IconButton
          sx={{ display: { xs: "block", sm: "none" } }}
          onClick={() => setOpen(!open)}
        >
          <MenuIcon />
        </IconButton>
      </ToolbarStyled>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        open={open}
        onClose={() => setOpen(!open)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box>
          {MenuItems.map((item, index) => (
            <MenuItem
              key={index}
              component={Link}
              to={`${item.link}`}
              onClick={() => setOpen(false)}
            >
              <Box display="flex">
                <Box>{item.icon}</Box>
                <Box marginLeft={2}>{item.name}</Box>
              </Box>
            </MenuItem>
          ))}
        </Box>
      </Menu>
    </AppBar>
  )
}
export default Navbar
